// extracted by mini-css-extract-plugin
module.exports = {"block":"moviethumb_block__F_wAU","image":"moviethumb_image__118k6","title":"moviethumb_title__2Cj-j","character":"moviethumb_character__1yEOJ"};